import { createRouteRef } from '@backstage/frontend-plugin-api';

/** Route to the team cost detail page, e.g. `/team-costs/team-dx`. */
export const teamCostsRouteRef = createRouteRef({
  params: ['teamSlug'],
});
